export default {"src":"/_next/static/media/member-taking-urine-test.colour.427dbfe9.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};